import priceTabStore, { defaultConfigTab } from "@/store/pricesTabStore";
import WidgetHeaderSubtitle from "./WidgetHeaderSubtitle";

// LQC-2575 - the active config name, shown beside "Prices" in the widget header so the
// name is visible without opening the Configs panel. Rendered only for the Prices
// widget, which keeps this price-store subscription off every other widget header.
export const PRICE_WIDGET_COMPONENT_KEY = "Price";

// The widget's cryptoID is its layout id, which is what PriceTable stores as `crypto`.
export function returnActivePriceConfigName(
  cryptoID: string,
  activeConfigIds: { crypto: string | undefined; activeTabId: number }[],
  configTabs: { id: number; displayName: string }[],
): string {
  const activeId =
    activeConfigIds.find((config) => config.crypto == cryptoID)?.activeTabId ??
    defaultConfigTab.id;

  // Default is the unnamed starting state - naming it in the header is just noise.
  if (activeId == defaultConfigTab.id) return "";

  return configTabs.find((config) => config.id == activeId)?.displayName ?? "";
}

const WidgetHeaderPriceConfigName = ({ cryptoID }: { cryptoID: string }) => {
  const configTabs = priceTabStore((state) => state.priceConfigTabs);
  const activeConfigIds = priceTabStore(
    (state) => state.activePricesConfigIdNumberStoreArr,
  );

  const displayName = returnActivePriceConfigName(
    cryptoID,
    activeConfigIds,
    configTabs,
  );

  if (!displayName) return null;

  return (
    <WidgetHeaderSubtitle
      testId={`WidgetHeaderPriceConfigName-${cryptoID}`}
      title={displayName}
    >
      <span className="truncate opacity-80">{displayName}</span>
    </WidgetHeaderSubtitle>
  );
};

export default WidgetHeaderPriceConfigName;
